$(function ()
{
    var request = new XMLHttpRequest();
    request.addEventListener('load', () => {
        const result = JSON.parse(request.responseText);
        if (result.Deprecated) 
        {
            var e = $(result.Html);
            $('body').append(e);
            $('head').append('<style>' + result.Style + '</style>')

            var shell = $('.deprecated-browser');
            shell.addClass('active');
            
            function close()
            {
                shell.removeClass("active");
                setTimeout(function () { shell.hide(); }, 1000);

                var expirationDate = new Date();
                expirationDate.setFullYear(expirationDate.getFullYear() + 1);

                document.cookie = 'deprecated-browser-dismissed=true; expires=' + expirationDate.toUTCString();
            }

            $('.deprecated-browser-close').click(close);
        }
    });

    request.open('GET', 'https://klasselotteriet.dk/gateway/webapi/api/browserdeprecation?forcedeprecated=false')
    request.send();
});
